import { ChangeDetectorRef, ElementRef, Injectable, Renderer2 } from '@angular/core';

import { DomElement } from '../models';
import { EventType } from '../util';

@Injectable()
export class OutsideClickListenerService {
  private documentClickListener;
  private outsideClickHandler: Function;

  constructor(private element: ElementRef, private renderer: Renderer2, private cd: ChangeDetectorRef) {
  }

  public bindDocumentClickListener(outsideClickHandler: Function): void {
    if (!this.documentClickListener) {
      this.outsideClickHandler = outsideClickHandler;
      this.documentClickListener = this.renderer.listen(
        DomElement.Document,
        EventType.Click,
        event => this.onDocumentClick(event)
      );
    }
  }

  public unbindDocumentClickListener(): void {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
      this.outsideClickHandler = null;
    }
  }

  private onDocumentClick(event): void {
    if (this.isOutsideClick(event.target)) {
      this.outsideClickHandler();
      this.cd.markForCheck();
    }
  }

  private isOutsideClick(target): boolean {
    return !this.element.nativeElement.contains(target);
  }
}
